import { Box } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
// import useVehiculesCriteria from './useVehiculesCriteria';

const VinExtraFilters = ({
  brands, models, enginesCode, enginesType, vin, filters = {}, onChange,
}) => {
  const onChangeX = (value, name) => {
    onChange({ target: { name, value } });
  };
  // reset sub selector
  useEffect(() => {
    onChange({ target: { name: 'brand', value: null } });
    onChange({ target: { name: 'model', value: null } });
    onChange({ target: { name: 'engineType', value: null } });
    onChange({ target: { name: 'engineCode', value: null } });
  }, [vin]);

  useEffect(() => {
    onChange({ target: { name: 'model', value: null } });
    onChange({ target: { name: 'engineType', value: null } });
    onChange({ target: { name: 'engineCode', value: null } });
  }, [filters.brand]);

  useEffect(() => {
    onChange({ target: { name: 'engineType', value: null } });
    onChange({ target: { name: 'engineCode', value: null } });
  }, [filters.model]);

  useEffect(() => onChange({ target: { name: 'engineCode', value: null } }),
    [filters.engineType]);

  // select if only is one option
  useEffect(() => {
    if (models.length === 1) {
      onChange({ target: { name: 'model', value: models[0] } });
    }
  }, [models]);

  useEffect(() => {
    if (enginesType.length === 1) {
      onChange({ target: { name: 'engineType', value: enginesType[0] } });
    }
  }, [enginesType]);

  const codesM = useMemo(() => enginesCode.filter((code) => code.type === filters.engineType),
    [enginesCode, filters.engineType]);

  useEffect(() => {
    if (codesM.length === 1) {
      onChange({ target: { name: 'engineCode', value: codesM[0].nme } });
    }
  }, [codesM]);

  return (
    <Box sx={{ display: 'flex', mt: 2 }}>
      {/* <AutoCompleteCmp
        options={[]}
        onChange={(event, value) => onChange(value, 'carType')}
        value={filters.carType}
        size="small"
        name="carType"
        isPrimaryTheme
        style={{ minWidth: 250, maxWidth: 250 }}
        label="type de véhicule"
      /> */}
      <AutoCompleteCmp
        options={brands}
        onChange={(event, value) => onChangeX(value, 'brand')}
        value={filters.brand}
        size="small"
        name="brand"
        isPrimaryTheme
        style={{ minWidth: 250, maxWidth: 250 }}
        label="contructeur"
      />
      <AutoCompleteCmp
        options={models}
        onChange={(event, value) => onChangeX(value, 'model')}
        value={filters.model}
        size="small"
        name="model"
        isPrimaryTheme
        style={{ minWidth: 180, maxWidth: 250 }}
        label="modéle moteur"
        disabled={!filters.brand}
      />
      <AutoCompleteCmp
        options={enginesType}
        onChange={(event, value) => onChangeX(value, 'engineType')}
        value={filters.engineType}
        size="small"
        name="engineType"
        getOptionLabel={(o) => o}
        filterOptions={((ops, v) => ops.filter(
          (o) => !v.inputValue || o?.toLowerCase().includes(v.inputValue.toLowerCase()),
        ))}
        isPrimaryTheme
        style={{ minWidth: 180, maxWidth: 250 }}
        label="type moteur"
        disabled={!filters.model}
      />
      <AutoCompleteCmp
        options={codesM.map((code) => code.name)}
        onChange={(event, value) => onChangeX(value, 'engineCode')}
        value={filters.engineCode}
        size="small"
        name="engineCode"
        getOptionLabel={(o) => o}
        filterOptions={((ops, v) => ops.filter(
          (o) => !v.inputValue || o?.toLowerCase().includes(v.inputValue.toLowerCase()),
        ))}
        isPrimaryTheme
        style={{ minWidth: 180, maxWidth: 250 }}
        label="code moteur"
        disabled={!filters.engineType}
      />
    </Box>
  );
};

export default VinExtraFilters;
